import { render, staticRenderFns } from "./index.vue?vue&type=template&id=233b6a07&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=233b6a07&prod&scoped=true&lang=less"
import style1 from "@/assets/style/pages/management/aiService/index.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b6a07",
  null
  
)

export default component.exports